module.exports = __webpack_public_path__ + "img/logout_2.d845a019.svg";